module.exports = __webpack_public_path__ + "img/R_logo.3f28e458.png";